var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.800781 7.3V12.5C0.800781 12.8448 0.958816 13.1754 1.24012 13.4192C1.52143 13.663 1.90296 13.8 2.30078 13.8H11.3008C11.6986 13.8 12.0801 13.663 12.3614 13.4192C12.6427 13.1754 12.8008 12.8448 12.8008 12.5V7.3M3.80078 3.4L6.80078 0.800003L9.80078 3.4M6.80078 0.800003V9.25",
    stroke: "#01152E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.a070b9dc302c40418f85d12a8d603997.svg";
export { ForwardRef as ReactComponent };